import { moedaComSimbolo } from 'dashboard/helper/moeda';

// A TABELA PADRÃO DO ASAAS, para quem ainda vai abrir a conta (11/10/2026).
// Victor: "coloca aquelas tarifas... é a tarifa padrão do Asaas. Pessoa ter
// mais informação". A advup NÃO tem acordo de tarifa (é a tabela de qualquer
// cliente do Asaas): a tela diz de onde veio e quando foi conferida, porque o
// Asaas muda a tabela sem avisar a gente. Fonte: FONTE abaixo.
export const FONTE = 'https://www.asaas.com/precos-e-taxas';
export const CONFERIDO_EM = '11/10/2026';

export const TARIFAS = {
  pix: 1.99,
  boleto: 1.99,
  cartaoFixo: 0.49,
  cartaoPercentual: '2,99%',
  promocional: 0.99,
  mesesPromocionais: 3,
};

// As linhas que a tela mostra, já escritas como dinheiro pelo leitor único.
export const linhasDasTarifas = () => [
  { chave: 'PIX', valor: moedaComSimbolo(TARIFAS.pix) },
  { chave: 'BOLETO', valor: moedaComSimbolo(TARIFAS.boleto) },
  {
    chave: 'CARTAO',
    valor: `${moedaComSimbolo(TARIFAS.cartaoFixo)} + ${TARIFAS.cartaoPercentual}`,
  },
];

export const promocao = () => ({
  valor: moedaComSimbolo(TARIFAS.promocional),
  meses: TARIFAS.mesesPromocionais,
});
